<template>
  <Layout :extraClasses="'d-flex'">
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="secondary"
      class="absolute-center"
    ></v-progress-circular>
    <v-layout column>
      <p class="section-header" style="padding-top: 0px!important; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
        <v-icon size="22" color="primary">receipt</v-icon>
        {{ $t("transactions.title") }}
      </p>
      <div class="balance-row">
        <span class="balance-label">
          {{ $t("balance_refund.current_balance") }}
        </span>
        <span class="balance-value">
          <span>{{ whole(userData.balance) }},</span>{{ decimal(userData.balance) }}
          <v-icon small color="#000230">{{ currency_symbol }}</v-icon>
        </span>
      </div>
      <div class="flex-grow-1 d-flex flex-column" style="height: 150px; overflow-y: auto;">
        <div v-if="transactions.length">
          <Transaction
            v-for="transaction in transactions"
            :key="transaction.id"
            :transaction="transaction"
            :routeNames="routeNames"
          />
        </div>
        <div
          v-else
          class="d-flex flex-column justify-center align-center flex-grow-1 mt-n15"
        >
          <icon
            :name="'paper_crossed'"
            width="80"
            color="#0002301A"
          />
          <span style="color: var(--primary-color-blue);" class="title">{{
            $t("transactions.no_transactions")
          }}</span>
        </div>
      </div>
      <v-btn
        v-if="!reachedEnd && transactions.length"
        text
        plain
        retain-focus-on-click
        class="font-weight-light"
        style="color: var(--primary-color-blue);"
        @click="loadMoreTransactions()"
        :loading="loading"
      >
        <v-icon left color="#000230"> remove_red_eye </v-icon>
        {{ $t("actions.see_more") }}
      </v-btn>
      <p
        v-else
        style="color: var(--primary-color-blue);"
        class="font-weight-light mt-5 mb-3 text-center subtitle-2"
      >
        {{ $t("transactions.all_transactions") }}
      </p>
      <TransactionsDialog :dialogData="dialogData" ref="transactionDialog" />
    </v-layout>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout.vue";
import TransactionsDialog from "@/components/dialogs/GenericDismissibleDialog";
import Transaction from "@/components/Transaction";
import { RequestService } from "../services/request.service";
import errorManager from "@/services/error.manager";
import { mapState } from "vuex";
import { whole, decimal } from "../utils/MoneyUtils";

const requestService = new RequestService();

export default {
  props: ["routeNames"],
  data() {
    return {
      dialogData: {
        primary_text: this.$t("transactions.sync_warning"),
      },
      loading: false,
      offset: 0,
      limit: 10,
      transactions: [],
      reachedEnd: false,
    };
  },
  components: { Layout, TransactionsDialog, Transaction },
  methods: {
    whole,
    decimal,
    getTransactions() {
      const context = this;
      this.loading = true;
      requestService
        .getTransactions(context, this.offset, this.limit)
        .then((transactions) => {
          context.loading = false;
          if (transactions.length === 0) {
            context.reachedEnd = true;
          } else {
            context.transactions.push.apply(context.transactions, transactions);
            if (transactions.length < context.limit) {
              context.reachedEnd = true;
            }
          }
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    },
    loadMoreTransactions() {
      this.offset += this.limit;
      this.getTransactions();
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      currency_symbol: (state) =>
        state.customization.customization.economics.currency_symbol
    }),
  },
  mounted() {
    if (!this.userData) requestService.getUserData(this);
    this.getTransactions();
    if (this.$route.params.showTransactionsWarningModal)
      this.$refs.transactionDialog.dialog = true;
  },
};
</script>
<style lang="css">
.order {
  color: var(--transaction-order) !important;
  fill: var(--transaction-order) !important;
}
.recharge,
.token {
  color: var(--transaction-recharge) !important;
  fill: var(--transaction-recharge) !important;
}
.recharge_refund,
.order_refund {
  color: var(--transaction-refund) !important;
  fill: var(--transaction-refund) !important;
}
.v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover)
  .v-btn__content {
  opacity: 1;
}
.section-header {
  color: var(--primary-color-blue);
  font-size: 18px;        
  font-weight: 600;       
  margin: 0;             
  display: inline-block;
  vertical-align: middle;
}
.balance-row {
  margin: 0 8px;             
  padding: 4px 0;            
  font-size: 14px;
  align-items: center;
}

.balance-label {
  font-size: 14px;
  font-weight: 500;
}

.balance-value {
  font-size: 16px;
  font-weight: 600;
}
</style>
